export enum DefectCodeListFormValue {
  ActionCheckBox = 'ActionCheckBox',
  Code = 'Code',
  Color = 'Color',
  Category = 'Category',
  SubCategory = 'SubCategory',
  Description = 'Description',
  AdditionalDescription = 'AdditionalDescription',
}
